import React from 'react';
import BidTalentDetail from './BidTalentDetail';
import AnalyticsProvider from '../shared/analytics/AnalyticsProvider';
import AnalyticsContext from '../shared/analytics/AnalyticsContext';
import withErrorBoundary from 'components/hoc/withErrorBoundary';
import themed from 'components/hoc/themed';

class BidTalent extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <AnalyticsProvider disableTracking={false}>
        <AnalyticsContext.Consumer>
          {({ trackEvents }) => (
            <BidTalentDetail
              trackEvents={trackEvents}
              ref={ourComponent => {
                window.ourComponent = ourComponent;
              }}
              {...this.props}
            />
          )}
        </AnalyticsContext.Consumer>
      </AnalyticsProvider>
    );
  }
}

const BidTalentWrapper = props => {
  const component = () => <BidTalent {...props} />;
  const context = {};
  return withErrorBoundary(component, context);
};

export default themed(BidTalentWrapper);
